<template>
</template>

<script>
import { mapState } from 'vuex';
import { buildPtDetailItem, ensureGtmLoaded, pushEcommerceEvent, resolvePrice, readMap ,writeMap} from 'assets/js/gtm';

export default {
    name: "PT502GTMViewItem",
    data() {
        return {
            eventSent: false,
        };
    },
    computed: {
        ...mapState('pt120', ['pt120Init']),
        ...mapState('pt125', ['pt125Init']),
        isPt125() {
            return !!(this.pt125Init && Array.isArray(this.pt125Init.detailList) && this.pt125Init.detailList.length);
        },
        productInfo() {
            if (this.isPt125) {
                return this.pt125Init.productInfo;
            }
            return this.pt120Init && this.pt120Init.productInfo ? this.pt120Init.productInfo : {};
        },
        navList() {
            if (this.isPt125) {
                return this.pt125Init && this.pt125Init.navList ? this.pt125Init.navList : [];
            }
            return this.pt120Init && Array.isArray(this.pt120Init.navList) ? this.pt120Init.navList : [];
        },
        gtmContainerId() {
            if (this.isPt125) {
                return this.pt125Init && this.pt125Init.gtmcontainerId ? this.pt125Init.gtmcontainerId : '';
            }
            return this.pt120Init && this.pt120Init.gtmcontainerId ? this.pt120Init.gtmcontainerId : '';
        },
        quantity() {
            return 1;
        },
        eventPayloadReady() {
            return !!this.gtmContainerId && !!this.productInfo.S_ITEM_NO;
        }
    },
    watch: {
        eventPayloadReady: {
            handler(ready) {
                if (ready) {
                    this.$nextTick(() => {
                        this.initAndPushViewItem();
                    })
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initAndPushViewItem();
        });
    },
    methods: {
        hasDetailComponentRoot() {
            return !!document.querySelector('#pt120') || !!document.querySelector('#pt120 .productTop');
        },
        canRunInContext() {
            return this.hasDetailComponentRoot();
        },
        initAndPushViewItem() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            this.$store.commit('setGtmId', this.gtmContainerId);
            ensureGtmLoaded();
            setTimeout(() => {
                this.pushViewItem();
            }, 200);
        },
        pushViewItem() {
            if (this.eventSent || !this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }

            const item = buildPtDetailItem(this.productInfo, this.navList);
            pushEcommerceEvent('view_item', {
                currency: 'JPY',
                value: resolvePrice(this.productInfo),
                items: [
                    Object.assign({}, item, { quantity: 1 }),
                ],
            });
            
            // URLから直接商品詳細ページにアクセスした場合、ローカルから参照元の記録を削除する
            if (!document.referrer && readMap()[item.item_id]) {
                const map =  readMap()
                delete map[item.item_id]
                writeMap(map)
            }
            this.eventSent = true;
        }
    }
}
</script>
